import CustomTablePagination from 'Components/CustomTablePagination'
import type { HeadCell } from 'Components/EnhancedTableHead/EnhancedTableHead'
import { WithLoader } from 'Components/WithLoader'
import { DeviceListRow } from 'Services/SalesManagement/Features/WalttiPosRemoteConfig/Components/DeviceListRow'
import type {
  DeviceConfigShape,
  DeviceParamShape
} from 'Services/SalesManagement/Features/WalttiPosRemoteConfig/walttiPosRemoteConfigSlice'
import { ROWS_PER_PAGE_DEFAULT } from 'Util/constants'
import { TableCell, TableHead, TableRow } from '@mui/material'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import type { FC } from 'react'
import { t } from 'ttag'

const DeviceList: FC<{
  rows: DeviceConfigShape[]
  loading: string
  params: DeviceParamShape
  handleChangePage: (event: unknown, newPage: number) => void
  count: number
}> = ({ rows, loading, params, handleChangePage, count }) => {
  const headCells: HeadCell[] = [
    {
      id: 'device_name',
      numeric: false,
      disablePadding: false,
      label: t`Device name`,
      sortable: false
    },
    {
      id: 'machine_id',
      numeric: false,
      disablePadding: false,
      label: t`Machine ID`,
      sortable: false
    }
  ]

  return (
    <WithLoader loading={loading === 'pending'} rows={ROWS_PER_PAGE_DEFAULT} height={33}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <TableHead>
              <TableRow>
                {headCells.map(cell => (
                  <TableCell key={cell.id}>{cell.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <DeviceListRow key={row.machine_id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomTablePagination
          count={count}
          page={params.page - 1}
          onPageChange={handleChangePage}
        />
      </Paper>
    </WithLoader>
  )
}

export { DeviceList }
